export function preventDefaultWrapper(cb: (evt: Event) => any) {
  return evt => {
    evt.preventDefault();

    return cb(evt);
  };
}
